import * as React from 'react';

export const RAPillar = (props: React.SVGProps<SVGPathElement>) => (
	<path id="RAPILLAR" stroke="#000" d="M279.5 203l-13 44.5 4.5 2 8.5-27.5v-19z" {...props} />
);
